import React from "react";
import Competition from "./Competition";
import sidebarShadow from "../../../Common/_assets/img/placeholder/sidebar-shadow.png";

const CompetitionsAwardsColumns = ({
	competitions,
	titleName,
	show_id,
	slug,
	award_count,
}) => {
	return (
		<>
			<div className="d-flex mb-5 pb-5 flex-md-fill flex-column align-items-center">
				<div className="sidebar__container--nomineelist-wrapper nomination__columns flex-md-fill row col-12 col-md-8">
					<div
						className="text-uppercase mt-2 mb-4 text-center d-flex align-items-center justify-content-center gap-2"
						style={{
							opacity: 0.5,
							// fontSize: "1rem",
							// letterSpacing: ".2rem",
							// marginTop: "2rem",
							// marginBottom: "2rem",
							fontSize: ".75rem",
							letterSpacing: ".2rem",
							marginTop: "2rem",
							marginBottom: "2rem",
						}}
					>
						{/*<span*/}
						{/*	style={{*/}
						{/*		fontSize: "1em",*/}
						{/*		color: "#e50914",*/}
						{/*		fontWeight: "500",*/}
						{/*	}}*/}
						{/*>*/}
						{/*	{award_count}*/}
						{/*</span>*/}
						{/*<span>*/}
						{/*	Emmy&reg; Nomination{award_count > 1 ? "s" : ""}*/}
						{/*</span>*/}
						<span>Nominations and Wins</span>
					</div>

					{competitions.map((competition, i) => {
						return (
							<div
								key={i}
								className="col-12 mt-3 d-flex justify-content-center"
							>
								<div
									className=""
									style={{
										display: "flex",
										flexDirection: " column",
										justifyContent: "center",
									}}
								>
									<Competition
										competition={competition}
										slug={slug}
										award_count={award_count}
									/>
								</div>
							</div>
						);
					})}

					<div className="sidebar__container--shadow d-none">
						<img src={sidebarShadow} className="" alt="Netflix" />
					</div>
				</div>
			</div>
		</>
	);
};

export default CompetitionsAwardsColumns;
